import { Strategy } from 'utility-ts-strategy';
import { ISectionAddCoreqButtonStrategy } from '../../../interfaces/scheduler_interfaces';

export let SectionAddCoreqButtonStrategy = new Strategy<ISectionAddCoreqButtonStrategy>({
  COURSE: {
    title: 'Add to my term plan',
    disabled: false,
    hide: false,
    satisfiedText: 'Planned'
  },
  ONE_TO_ONE: {
    title: 'Add to my schedule',
    disabled: false,
    hide: false,
    satisfiedText: 'Scheduled'
  },
  ONE_TO_MANY: {
    title: 'View Times',
    disabled: false,
    hide: false,
    satisfiedText: 'Scheduled'
  },
  CONFLICTING: {
    title: 'Conflict',
    disabled: true,
    hide: false
  },
  REGISTERED: {
    title: 'Registered',
    disabled: true,
    hide: false,
    satisfiedText: 'Registered'
  },
  SECTION_PICKED: {
    title: 'Scheduled',
    disabled: false,
    hide: false,
    satisfiedText: 'Scheduled'
  }
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_corequisite/strategies/section_coreq_strategy.ts